import { STAGE, Stage } from "../constants"

export function isProduction() {
    return STAGE === Stage.Production
}
